import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactForm from './components/ContactForm';

export default function AboutPage() {
  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: '关于我们' },
  ];

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <div className="bg-background-100/70 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-6 md:px-10 py-6">
            <Breadcrumb items={breadcrumbItems} />
          </div>
        </div>
        <BrandIntro />
        <Reputation />
        <ContactForm />
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "关于我们 - 裸肌研究所",
        "description": "裸肌研究所致力于传播全裸护肤理念，用科学的态度、极简的方法帮助每个人找到最适合自己的护肤方案。了解我们的品牌故事、核心团队和联系方式。",
        "url": "https://nudezone.github.io/about",
        "inLanguage": "zh-CN",
        "isPartOf": { "@type": "WebSite", "name": "裸肌研究所", "url": "https://nudezone.github.io" }
      }) }}></script>

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://nudezone.github.io" },
          { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "https://nudezone.github.io/about" }
        ]
      }) }}></script>
    </>
  );
}